import FilterParameter from '~/utils/FilterParameter/FilterParameter';

export default class Meta {
	searchFilters: FilterParameter<string | string[]>[];

	constructor(searchFilters: FilterParameter<string | string[]>[]) {
		this.searchFilters = searchFilters;
	}
}
